import React from 'react'

const PartnersSection = () => {
    return (
        <div className="pb-8 md:pb-16 bg-[#0F5132]">
            <div className="max-w-7xl mx-auto ">
                <div className="w-full">
                    <div className="flex flex-col justify-center items-center px-8 mb-1 md:mb-4 py-6">
                        <h3 className="text-white text-base sm:text-4xl font-display-fran font-semibold">Our partners</h3>
                    </div>
                    <div className="rates-container overflow-hidden">
                        <div className="rates-scroll flex items-center space-x-20">
                            <img src="/images/tecvinson.png" alt="Tecvinson" className="flex-shrink-0 h-10 lg:h-12 w-auto" />
                            <img src="/images/tecvinson_academy.png" alt="Tecvinson Academy" className="flex-shrink-0 h-10 lg:h-12 w-auto" />
                            <img src="/images/cherrybrooks.png" alt="Cherrybrooks" className="flex-shrink-0 h-10 lg:h-12 w-auto" />
                            <img src="/images/tecvinson.png" alt="Tecvinson" className="flex-shrink-0 h-10 lg:h-12 w-auto" />
                            <img src="/images/tecvinson_academy.png" alt="Tecvinson Academy" className="flex-shrink-0 h-10 lg:h-12 w-auto" />
                            <img src="/images/cherrybrooks.png" alt="Cherrybrooks" className="flex-shrink-0 h-10 lg:h-12 w-auto" />
                            <img src="/images/tecvinson.png" alt="Tecvinson" className="flex-shrink-0 h-10 lg:h-12 w-auto" />
                            <img src="/images/tecvinson_academy.png" alt="Tecvinson Academy" className="flex-shrink-0 h-10 lg:h-12 w-auto" />
                            <img src="/images/cherrybrooks.png" alt="Cherrybrooks" className="flex-shrink-0 h-10 lg:h-12 w-auto" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PartnersSection